import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { RollbackExchangerTransfer } from './types'
import qs from 'qs'

export const submitRollback = createEvent<RollbackExchangerTransfer>()

export const rollbackExchangerTransferRequest = fx<RollbackExchangerTransfer, void>(
  {
    method: 'PUT',
    url: `/exchanger_transfer/`,
  },
)

sample({
  clock: submitRollback,
  fn: ({ requestId, rollbackReason }) => {
    return {
      body: {
        requestId: requestId,
        status: 'STATUS_ROLLING_BACK',
        rollbackReason,
      },
      url: `/exchanger_transfer/${requestId}?${qs.stringify({
        populate: `["ExchangerTransfer.client", "ExchangerTransfer.exchanger", "ExchangerTransfer.account", "Exchanger.owner"]`,
      })}`,
    }
  },
  target: rollbackExchangerTransferRequest,
})
